import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { apiAddDenestImpcMapping } from '../../add-denest-mapping/api/DenestImpcMappingAddAPI';
import { apiDeactivateDenestImpcMapping } from '../../deactivate-denest-mapping/api/DeactivateDenestImpcMappingAPI';
import { MRD_DENEST_IMPC_MAPPING_ADD_REQUEST, MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST } from '../actions/types/DenestImpcMappingActionTypes';
import {
  postDenestImpcMappingAddFailureActionCreator,
  postDenestImpcMappingAddSuccessActionCreator,
  putDenestImpcMappingDeactivateSuccessActionCreator,
  putDenestImpcMappingDeactivateFailureActionCreator,
} from '../actions/DenestImpcMappingActions';
import { triggerTableReload } from '../../../../../common/list-table/actions/ListTableActions';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';

function* doDenestImpcMappingAddWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiAddDenestImpcMapping, action.payload);
    yield put(postDenestImpcMappingAddSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.denestimpcmapping.add.success'),
    }));
  } catch (error) {
    yield put(postDenestImpcMappingAddFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message,
    }));
  }
}

function* doDenestImpcMappingDeactivateWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiDeactivateDenestImpcMapping, action.payload);
    yield put(putDenestImpcMappingDeactivateSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.denestimpcmapping.deactivate.success'),
    }));
    yield put(triggerTableReload(TableDefinitions.MRD_DENEST_IMPC_MAPPING.id));
  } catch (error) {
    yield put(putDenestImpcMappingDeactivateFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message,
    }));
  }
}

function* doDenestImpcMappingAddWatcher() {
  yield takeLatest(MRD_DENEST_IMPC_MAPPING_ADD_REQUEST, doDenestImpcMappingAddWorker);
  yield takeLatest(MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST, doDenestImpcMappingDeactivateWorker);
}

export default doDenestImpcMappingAddWatcher;
